// extracted by mini-css-extract-plugin
module.exports = {"container":"faqItem-module--container--1Ku35","question":"faqItem-module--question--3Jeoi","answer":"faqItem-module--answer--1wg9N"};